import { PatientRecommendations } from '../../domain/PatientRecommendations';
import apiClient from '../../../../shared/infrastructure/api/client';

/** Whose recommendations: one patient's, a couple's or a group's. */
export type RecommendationsSubject = 'patient' | 'couple' | 'group';

const BASE: Record<RecommendationsSubject, string> = {
    patient: '/patients',
    couple: '/couple-patients',
    group: '/group-patients',
};

/** Accepts the older `isCouple` flag as well as the kind, so callers can move over one at a time. */
function kindOf(subject?: boolean | RecommendationsSubject): RecommendationsSubject {
    if (typeof subject === 'string') return subject;
    return subject ? 'couple' : 'patient';
}

export class PatientRecommendationsRepository {
    async getRecommendations(
        patientId: string,
        subject?: boolean | RecommendationsSubject,
    ): Promise<PatientRecommendations | null> {
        try {
            const url = `${BASE[kindOf(subject)]}/${patientId}/recommendations`;
            const response = await apiClient.get<PatientRecommendations>(url);
            return response.data;
        } catch (error) {
            console.error('Failed to fetch recommendations:', error);
            return null;
        }
    }

    async refreshRecommendations(
        patientId: string,
        subject?: boolean | RecommendationsSubject,
    ): Promise<PatientRecommendations | null> {
        try {
            const url = `${BASE[kindOf(subject)]}/${patientId}/recommendations/refresh`;
            const response = await apiClient.post<PatientRecommendations>(url);
            return response.data;
        } catch (error) {
            console.error('Failed to refresh recommendations:', error);
            return null;
        }
    }
}
